module.exports = __webpack_public_path__ + "img/application-active.f9a937e7.svg";